import { createAction, createReducer } from 'deox';

export type ConsumerSearchResult = 'existingAccount' | 'error' | undefined;

export interface EnhancedCheckout {
  consumerSearchResult: ConsumerSearchResult;
}

const defaultState: EnhancedCheckout = {
  consumerSearchResult: undefined,
};

export const setEnhancedCheckoutState = createAction(
  'SET_ENHANCED_CHECKOUT_STATE',
  resolve => (enhancedCheckout: EnhancedCheckout) => resolve(enhancedCheckout),
);

export const enhancedCheckoutReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(setEnhancedCheckoutState, (state, { payload }) => ({
      ...state,
      ...payload,
    })),
  ],
);

interface MountedState {
  enhancedCheckout: EnhancedCheckout;
}

export const selectEnhancedCheckout = (
  state: MountedState,
): EnhancedCheckout => {
  return state.enhancedCheckout;
};

export default enhancedCheckoutReducer;
